import { Entity } from '@/domain/document-processing/types/entity-types';
import { EucData } from '@/domain/document-processing/types/euc-types';

export interface ProcessingResult {
  id: string;
  documentId: string;
  storageDocumentId?: string;
  status: 'completed' | 'failed' | 'processing' | 'review_required' | 'unknown';
  entities: Entity[];
  processingTime: number;
  error?: string;
  progress?: number;
  fileName?: string;
  eucData?: EucData;
  provider?: string;
  // Flag indicating that some providers failed but at least one succeeded
  partialSuccess?: boolean;
  // Information about providers that failed during processing
  failedProviders?: Array<{
    provider: string;
    error: string;
  }>;
  unresolvedVisualIdentities?: UnresolvedVisualIdentity[];
  humanIdentityReviews?: import('./identity-review-types').HumanIdentityReview[];
  // Deduplication summary for UI display
  deduplicationSummary?: {
    originalCount: number;
    consolidatedCount: number;
    duplicatesRemoved: number;
    providers: string[];
    uniqueEntitiesByType: Record<string, number>;
    allUniqueValues: string[];
  };
}

export interface ProcessingResultViewModel extends ProcessingResult {
  fileName?: string;
  fileType?: string;
  documentCategory?: string;
  documentMetadata?: any;
  documentSpecificDetails?: any;
  transactionDetails?: any;
  shippingDetails?: any;
  progress?: number;
}

export interface FileUploadProps {
  onFilesSelected: (files: File[]) => Promise<void>;
}

export interface BatchListProps {
  files: File[];
  onRemove: (file: File) => void;
}

export interface UnresolvedVisualIdentity {
  occurrenceId: string;
  status: 'unresolved';
  resolutionCode:
    | 'missing_source_region'
    | 'invalid_source_region'
    | 'crop_failed'
    | 'reader_failed'
    | 'insufficient_independent_readers'
    | 'reader_disagreement'
    | 'material_ambiguity'
    | 'restricted_evidence_unavailable';
  sourceRegionId: string;
  pageNumber: number;
  sourceFieldType: 'person_name' | 'print_name' | 'signature';
  cropHash?: string;
  independenceGroups: string[];
  reviewEvidenceId?: string;
  restrictedEvidenceAvailable: boolean;
}

export function unresolvedVisualIdentityLabel(
  identity: UnresolvedVisualIdentity
): string {
  switch (identity.sourceFieldType) {
    case 'signature':
      return 'Signature';
    case 'print_name':
      return 'Signatory name';
    case 'person_name':
      return 'Person named';
  }
}
